import { render, staticRenderFns } from "./downLoadPage.vue?vue&type=template&id=f2c5efb8&scoped=true"
import script from "./downLoadPage.vue?vue&type=script&lang=js"
export * from "./downLoadPage.vue?vue&type=script&lang=js"
import style0 from "./downLoadPage.vue?vue&type=style&index=0&id=f2c5efb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c5efb8",
  null
  
)

export default component.exports